module.exports = __webpack_public_path__ + "static/media/Lato-Regular.2d36b1a9.ttf";